// adapted from rental-manager-web

function rafAsync() {
  return new Promise((resolve) => {
    // equivalent of requestAnimationFrame(resolve)
    setTimeout(resolve, 0);
  });
}

const oneTrustUtils = {
  // utility function to wait for OneTrust to be initialized
  // OneTrust is initialized in the Footer from @zillow/zrs-comet
  waitForOptanon(maxTime = 5 * 1000, initialTime = new Date().getTime()) {
    const currentTime = new Date().getTime();
    if (currentTime - initialTime > maxTime) {
      // don't wait for longer than maxTime
      return Promise.reject({ message: 'Waiting for Optanon timed out' });
    }
    if (typeof Optanon === 'undefined') {
      return rafAsync().then(() => oneTrustUtils.waitForOptanon(maxTime, initialTime));
    }
    return Promise.resolve(true);
  },
};

export default oneTrustUtils;
